import styled, { css, down } from "@xstyled/styled-components";

import { Button } from "@otta/design";
import { palette } from "@otta/design-tokens";

export const DeleteButton = styled(Button)`
  color: red;
  border-color: red;
  background: ${palette.grayscale.shade50};
  margin: 0;

  :hover {
    color: red-600;
    border-color: red-600;
    background: ${palette.brand.grey};
  }

  ${down(
    "tablet",
    css`
      margin-top: sm;
    `
  )}
`;
